import { createIsomorphicFn } from "@tanstack/react-start";
import { getCookie, getRequestHeader } from "@tanstack/react-start/server";
import {
  acceptedLocales,
  isCoveredLocale,
  resolveLocale,
} from "@/engine/support/locales";
import { LOCALE_COOKIE } from "@/engine/support/localeCookie";
import { getLocale } from "@/engine/state/locale";

/**
 * The locale this render is in, on whichever side of the seam is asking.
 *
 * The root route calls it as a loader, so on a served page it runs here on the
 * server and its answer travels to the client as loader data — the client
 * hydrates against the language it was actually sent rather than resolving one
 * of its own and hoping the two agree. They can disagree: a cookie the server
 * read and a `localStorage` value the client reads are two stores, and #310 is
 * what happens when they differ.
 *
 * The client half is for the loader running again later — an invalidation, or a
 * navigation that remounts the root match — where the store is the live answer
 * and there is no request to read. `createIsomorphicFn` is what keeps the
 * server half, and the request API it reaches for, out of the browser bundle.
 */
export const initialLocale = createIsomorphicFn()
  .server(() => {
    const chosen = getCookie(LOCALE_COOKIE);
    if (chosen && isCoveredLocale(chosen)) return chosen;
    return resolveLocale(acceptedLocales(getRequestHeader("accept-language")));
  })
  .client(() => getLocale());
